import { ElementType, InputHTMLAttributes } from 'react'

import Typography from '@/components/base/typography'

import { cn } from '@/lib/utils'
import { WPCF7FormField } from '@/types'

type FormControlProps = Omit<
  InputHTMLAttributes<HTMLInputElement>,
  'onChange' | 'onBlur'
> &
  Partial<
    WPCF7FormField & {
      error?: boolean
      options?: { value: string; text: string }[]
      // eslint-disable-next-line no-unused-vars
      onChange?: (e: any) => void
      // eslint-disable-next-line no-unused-vars
      onBlur?: (e: any) => void
      theme?: 'dark' | 'light'
    }
  >

const FormControl = ({
  id,
  type,
  label,
  checked,
  // eslint-disable-next-line no-unused-vars
  options,
  placeholder,
  className,
  children,
  theme = 'light',
  error,
  ...props
}: FormControlProps) => {
  const Component = (type === 'textarea' ? 'textarea' : 'input') as ElementType

  return (
    <div
      className={cn('relative', className, {
        hidden: type === 'hidden'
      })}
    >
      {type === 'consent' ? (
        <label
          // htmlFor={id}
          className="relative flex items-start space-x-[1rem]"
        >
          <input
            id={id}
            type="checkbox"
            checked={checked}
            className={cn('h-[1.5rem] w-[1.5rem] opacity-0', {
              '[&:checked+div]:after:bg-havana': theme === 'light'
            })}
            {...props}
          />
          <div
            className={cn(
              'absolute -top-0 left-0 !m-0 h-[1.5rem] w-[1.5rem] shrink-0 cursor-pointer rounded-full border',
              'after:absolute after:left-1/2 after:top-1/2 after:h-[1rem] after:w-[1rem] after:-translate-x-1/2 after:-translate-y-1/2 after:rounded-full',
              {
                'border-havana': theme === 'light',
                'border-error': error
              }
            )}
          />
          <Typography
            variant="small"
            className={cn(
              'text-left font-gillsans font-light text-light',
              '[&>#required-data]:mt-[1rem] [&>#required-data]:inline-block',
              {
                'text-dark': theme === 'light',
                '!text-error': error
              }
            )}
          >
            {label}
          </Typography>
        </label>
      ) : (
        <Component
          id={id}
          type={type}
          placeholder={placeholder || label}
          className={cn(
            'flex h-[4rem] w-full rounded-[3rem] bg-transparent px-[1.5rem]',
            'font-gillsans text-label uppercase',
            'appearance-none border outline-none',
            'focus:ring-2',
            {
              'border-havana text-dark placeholder:text-dark': theme === 'light'
            },
            {
              'focus:havana focus:ring-havana/30': !error && theme === 'light',
              'border-error focus:ring-error/20': error
            }
          )}
          {...props}
        />
      )}
      {children}
    </div>
  )
}

export default FormControl
